export default function FeaturesGrid() {
  const features = [
    {
      icon: 'ri-medicine-bottle-line',
      color: 'text-primary-500',
      bg: 'bg-primary-500/10',
      title: 'Medication reminders',
      desc: 'Never miss a dose with gentle reminders and family tracking.',
    },
    {
      icon: 'ri-restaurant-line',
      color: 'text-secondary-500',
      bg: 'bg-secondary-500/10',
      title: 'Meal & hydration tracking',
      desc: 'Log meals and water intake to ensure proper nutrition.',
    },
    {
      icon: 'ri-stethoscope-line',
      color: 'text-primary-500',
      bg: 'bg-primary-500/10',
      title: 'Doctor appointment reminders',
      desc: 'Keep appointments top of mind with smart alerts.',
    },
    {
      icon: 'ri-calendar-check-line',
      color: 'text-accent-500',
      bg: 'bg-accent-500/10',
      title: 'Family visit scheduling',
      desc: 'Plan and coordinate visits so no one is forgotten.',
    },
    {
      icon: 'ri-emotion-happy-line',
      color: 'text-secondary-500',
      bg: 'bg-secondary-500/10',
      title: 'Daily wellbeing check-ins',
      desc: 'Simple mood and health checks to spot changes early.',
    },
    {
      icon: 'ri-file-text-line',
      color: 'text-primary-500',
      bg: 'bg-primary-500/10',
      title: 'Caregiver notes',
      desc: 'Share observations and updates with the whole family.',
    },
    {
      icon: 'ri-alarm-warning-line',
      color: 'text-accent-400',
      bg: 'bg-accent-400/10',
      title: 'Emergency SOS alerts',
      desc: 'One-touch alerts that instantly notify family and contacts.',
    },
    {
      icon: 'ri-chat-heart-line',
      color: 'text-accent-500',
      bg: 'bg-accent-500/10',
      title: 'Family communication hub',
      desc: 'All updates in one place — no more scattered messages.',
    },
  ];

  return (
    <section id="solution" className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            One simple care circle around your loved one
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            CareBridge brings family members, caregivers, and elderly parents into one shared app so everyone can see what matters most.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 hover:shadow-md transition-all duration-300 border border-background-200/70 group cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${feature.bg} mb-4`}>
                <i className={`${feature.icon} ${feature.color} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600/80 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}